/* eslint-disable no-await-in-loop */
import sendMissedActivity from "@api/job/sendMissedActivity";
import { CHAT_TYPES } from "@constants/chat";
import { CONVERSATION_COLlECTION, UNREAD_REALTIME, USER_COLlECTION } from "@fb/const";
import { db, realtimeDb } from "@fb/db";
import { get, ref } from "firebase/database";
import { doc, getDoc, updateDoc } from "firebase/firestore";

import { useAppSelector } from "@app/hooks";

import { Missed_Message_Type } from "@pages/chat/Conversation/type";

import { User } from "@dto/user";

export const markInactiveUserUnreadMessage = async ({
  userId,
  conversationId,
  sendData,
  type,
}: {
  userId: string;
  conversationId: string;
  sendData?: any;
  type?: string;
}) => {
  try {
    const unreadUser = await get(ref(realtimeDb, `${UNREAD_REALTIME}/${userId}`));

    const isUnreadP2P = type === CHAT_TYPES.P2P;
    const unreadIds = await getDoc(doc(db, USER_COLlECTION, userId)).then((doc) =>
      isUnreadP2P
        ? doc?.data()?.unreadP2PIds || []
        : doc?.data()?.unreadRoundTableIds || []
    );
    const unreadData = unreadUser?.val() || {};
    // If user is not active in this conversation then set unread

    if (unreadData.active !== conversationId && !unreadIds.includes(conversationId)) {
      // Send missed activity notification
      await sendMissedActivity(conversationId, {
        ...sendData,
        userId,
        type: isUnreadP2P ? Missed_Message_Type.P2P : Missed_Message_Type.PROJECT,
      });

      // Update unread roundtable IDs for user
      await updateDoc(doc(db, USER_COLlECTION, userId), {
        ...(isUnreadP2P
          ? { unreadP2PIds: [...unreadIds, conversationId] }
          : { unreadRoundTableIds: [...unreadIds, conversationId] }),
      });
    }

    return { ...unreadData };
  } catch (error) {
    console.error(`Error checking status for userId ${userId}:`, error);
  }
};

export const useChatManagement = () => {
  const { userInfo } = useAppSelector((state) => state.auth);

  const doSendNotificationToUsers = async (
    conversationId: string,
    sendData?: unknown
  ) => {
    const conversationDoc = await getDoc(
      doc(db, CONVERSATION_COLlECTION, conversationId)
    );
    const conversationData = conversationDoc?.data();

    // Get list of participants from activity
    const partner = conversationData?.participantsList.filter(
      (u: User) => u.id !== userInfo.user.id
    );

    for (const user of partner) {
      await markInactiveUserUnreadMessage({
        userId: user.id,
        conversationId,
        sendData,
        type: conversationData?.type,
      });
    }
  };

  return {
    doSendNotificationToUsers,
  };
};
